import { ParentShell } from '@/features/parent/ParentShell';
import { GoalsPanel } from '@/features/goals/GoalsPanel';

/**
 * Goals a guardian sets with their teen. [Parent step 24]
 *
 * Its own page rather than a card on the console: setting one is a
 * conversation, not a glance, and it deserves the room.
 */
export function GoalsPage() {
  return (
    <ParentShell
      title="Goals"
      description="What your teen is working towards. Progress comes from work they have actually done."
    >
      <GoalsPanel canEdit />
    </ParentShell>
  );
}
